"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Homepage = exports.AvailableCompositions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const remotion_1 = require("remotion");
const container = {
    width: 800,
    margin: 'auto',
    paddingLeft: 20,
    paddingRight: 20,
    fontFamily: 'sans-serif',
    lineHeight: 1.5,
};
const pre = {
    display: 'block',
    backgroundColor: '#f7f7f7',
    whiteSpace: 'nowrap',
    padding: 16,
    fontFamily: 'monospace',
    borderRadius: 5,
    fontSize: 15,
    overflowX: 'auto',
};
const AvailableCompositions = () => {
    const [comps, setComps] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        let timeout = null;
        const check = () => {
            if (window.ready === true) {
                setComps(window.getStaticCompositions());
            }
            else {
                timeout = setTimeout(check, 250);
            }
        };
        check();
        return () => {
            if (!timeout) {
                return;
            }
            clearTimeout(timeout);
        };
    }, []);
    const showComps = (0, react_1.useCallback)(() => {
        window.location.search = '?evaluation=true';
    }, []);
    if (!remotion_1.Internals.getIsEvaluation()) {
        return ((0, jsx_runtime_1.jsx)("button", Object.assign({ type: "button", onClick: showComps }, { children: "Click here to see a list of available compositions." }), void 0));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { children: [comps === null ? (0, jsx_runtime_1.jsx)("p", { children: "Loading compositions..." }, void 0) : null, (0, jsx_runtime_1.jsx)("ul", { children: comps === null
                    ? null
                    : comps.map((c) => {
                        return (0, jsx_runtime_1.jsx)("li", { children: c.id }, c.id);
                    }) }, void 0)] }, void 0));
};
exports.AvailableCompositions = AvailableCompositions;
const Homepage = () => {
    const url = window.location.origin + window.location.pathname;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: container }, { children: [(0, jsx_runtime_1.jsx)("h1", { children: "Remotion Bundle" }, void 0), "This is a website which contains a bundled Remotion video. You can render videos based on this URL.", (0, jsx_runtime_1.jsx)("h2", { children: "Available compositions" }, void 0), (0, jsx_runtime_1.jsx)(exports.AvailableCompositions, {}, void 0), (0, jsx_runtime_1.jsx)("h2", { children: "How to render" }, void 0), "Locally: ", (0, jsx_runtime_1.jsx)("br", {}, void 0), (0, jsx_runtime_1.jsx)("br", {}, void 0), (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: pre }, { children: ["npx remotion render ", url, " ", '<comp-name> <output-location>'] }), void 0), (0, jsx_runtime_1.jsx)("br", {}, void 0), (0, jsx_runtime_1.jsx)("br", {}, void 0), "With Remotion Lambda: ", (0, jsx_runtime_1.jsx)("br", {}, void 0), (0, jsx_runtime_1.jsx)("br", {}, void 0), (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: pre }, { children: ["npx remotion lambda render ", url, " ", '<comp-name>'] }), void 0), (0, jsx_runtime_1.jsx)("br", {}, void 0), (0, jsx_runtime_1.jsxs)("p", { children: ["You can also render still images, and use the Node.JS APIs", ' ', (0, jsx_runtime_1.jsx)("code", { children: "getCompositions()" }, void 0), ", ", (0, jsx_runtime_1.jsx)("code", { children: "renderMedia()" }, void 0), ",", ' ', (0, jsx_runtime_1.jsx)("code", { children: "renderMediaOnLambda()" }, void 0), ", ", (0, jsx_runtime_1.jsx)("code", { children: "renderStill()" }, void 0), " and", ' ', (0, jsx_runtime_1.jsx)("code", { children: "renderStillOnLambda()" }, void 0), " with this URL."] }, void 0), (0, jsx_runtime_1.jsxs)("p", { children: ["Visit", ' ', (0, jsx_runtime_1.jsx)("a", Object.assign({ href: "https://remotion.dev/docs", target: "_blank" }, { children: "remotion.dev/docs" }), void 0), ' ', "to read the documentation."] }, void 0)] }), void 0));
};
exports.Homepage = Homepage;
